import { gql } from '@apollo/client';

export const PROFILE = gql`
  query Profile {
    profile {
      id     
      firstName
      lastName
      registerNumber
      phone
      email

      isPhoneVerified
      isEmailVerified

      mainAddress {
        cityId
        districtId
        quarterId
        buildingNumber

        floor
        doorNumber
        entrance
        code
        note
      }
    }
  }
`;

export const PROFILE_WITH_ADDRESS = gql`
  query ProfileWithAddress {
    profile {
      id     
      firstName
      lastName
      phone
      email
      registerNumber

      isPhoneVerified
      isEmailVerified

      mainAddress {
        cityId
        districtId
        quarterId
        buildingNumber

        floor
        doorNumber
        entrance
        code
        note
      }
    }
  }
`;

export const CART_ITEMS = gql`
  query CartItems {
    cartItems {
      id
      customerId
      productId
      quantity
      product {
        id
        name
        thumbnail
        price
        discountPrice
        isSalonExclusive
        salonDiscountPercent
      }
    }
  }
`;

export const COUNT_CART_ITEMS = gql`
  query Query {
    cartItemCount
  }
`;

export const ADDRESS = gql`
  query CustomerAddress {
    customerAddress {
      cityId
      districtId
      quarterId
      buildingNumber

      floor
      doorNumber
      entrance
      code
      note
    }
  }
`;

export const ORDERS = gql`
  query CustomerOrders($paymentStatus: String, $status: OrderStatus, $page: Int, $limit: Int) {
    customerOrders(paymentStatus: $paymentStatus, status: $status, page: $page, limit: $limit) {
      id
      total
      paymentStatus
      createdAt
      orderNumber
      status
      items {
        id
        quantity
        productId
        product {
          id
          name
          thumbnail
          price
          discountPrice
        }
      }
    }
  }
`;

export const OREDER_POLL = gql`
  query CustomerOrder($id: ID!) {
    customerOrder(id: $id) {
      id
      paymentStatus
      paymentData
    }
  }
`;

export const ORDER_DETAIL = gql`
  query CustomerOrder($customerOrderId: ID!) {
    customerOrder(id: $customerOrderId) {
      id
      total
      createdAt
      paymentStatus
      remainingPayment
      orderNumber
      status
      registerNumber
      paymentData
      description
      pickup
      items {
        id
        quantity
        productId
        product {
          id
          name
          thumbnail
          price
          discountPrice
        }
      }
    }
  }
`;

export const FAVORITES = gql`
  query CustomerFavorites($page: Int, $limit: Int) {
    customerFavorites(page: $page, limit: $limit) {
      id
      name
      images
      video
      code
      price
      discountPrice
      discount
      status
      favorite
      colors
      sizeKind
      category {
        name
        slug
      }
      brand {
        name
        slug
        id
      }
      variants {
        id
        size
        stock
      }
    }
  }
`;

export const LOYALTY_TRANSACTIONS = gql`
  query CustomerLoyaltyTransactions($page: Int, $limit: Int) {
    customerLoyaltyTransactions(page: $page, limit: $limit) {
      id
      type
      points
      memo
      expiresAt
      createdAt
      used_at
      balanceAfter
    }
  }
`;

export const LOYALTY_ACCOUNT = gql`
  query CustomerLoyaltyAccount {
    customerLoyaltyAccount {
      id
      balance
      lifetimeRedeemed
      lifetimeEarned
    }
  }
`;

export const CUSTOMER_SUBSCRIPTIONS = gql`
  query CustomerSubscriptions {
    customerSubscriptions {
      id
      instructorId
      isActive
      currentPeriodEnd
      instructor {
        id
        avatar
        name
      }
    }
  }
`;
